export const LAYOUT_TYPE = {
   SCHOOL: 'SCHOOL',
   SCHOOL_UNION: 'SCHOOL_UNION',
   SCHOOL_LEAGUE: 'SCHOOL_LEAGUE',
   TOURNAMENT: 'TOURNAMENT',
   FOOTBALL_TOURNAMENT: 'FOOTBALL_TOURNAMENT',
   SCHOOL_CHALLENGE: 'SCHOOL_CHALLENGE'
};
